import { render, staticRenderFns } from "./VideoServers.vue?vue&type=template&id=49025e17"
import script from "./VideoServers.vue?vue&type=script&lang=js"
export * from "./VideoServers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports